import { render, staticRenderFns } from "./CalendarDetail.vue?vue&type=template&id=ad32ae2e&scoped=true"
import script from "./CalendarDetail.vue?vue&type=script&lang=js"
export * from "./CalendarDetail.vue?vue&type=script&lang=js"
import style0 from "./CalendarDetail.vue?vue&type=style&index=0&id=ad32ae2e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad32ae2e",
  null
  
)

export default component.exports